module.exports = __webpack_public_path__ + "static/media/cube-logo.249a8aad.png";